/**
 * Side-effect module: registers the Instance Advice reducer with the store.
 *
 * Imported at the top of the advice page (and by the feature's index), so the
 * slice is injected with the chunk that needs it. injectReducer is idempotent.
 */
import { injectReducer } from '@app/store';

import reducer from './slice';

injectReducer('costAdvice', reducer);
